import { useCallback, useMemo } from "react";

import { createData } from "@api/crud";
import { apiUsersEndpoints } from "@api/Endpoints";

import {
  AzureApplicationUserModel,
  CreateApiUserRequest
} from "../models/api-users-models";

export function useCreateApiUser() {
  const createCallback = useCallback(
    async (organizationId: string, apiUserName: string) => {
      const url = apiUsersEndpoints.createApiUser();

      const requestData: CreateApiUserRequest = {
        organizationId: organizationId,
        displayName: apiUserName
      };

      return await createData<CreateApiUserRequest, AzureApplicationUserModel>(
        url,
        requestData
      );
    },
    []
  );

  return useMemo(
    () => ({
      createApiUser: createCallback
    }),
    [createCallback]
  );
}
